module.exports = __webpack_public_path__ + "assets/img/busy_4.df70319d.png";